import React from 'react';
import cx from 'classnames';

import Text from '../Text';

import styles from './LineNumber.module.scss';
import usePresenter from './LineNumber.presenter';
import getProps from './LineNumber.props';
import { LineNumberCombinedProps } from './types';

const LineNumber: React.FC<LineNumberCombinedProps> = (props) => {
  const {
    className,
    classes,
    text,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.lineNumber;

  return (
    <div className={cx(currentStyle, className)}>
      <Text
        className={cx(styles.text, classes?.text)}
        {...internalProps.text}
        {...text}
      />
    </div>
  );
};

export default LineNumber;
